import React from 'react';
import logo from '../images/Group3.svg';

const Loading = () => {
  return (
    <div className='loading-spinner'>
      <img src={logo} alt='logo' />
    </div>
  );
};

export default Loading;
